import { HStack, Text, VStack } from '@chakra-ui/react';
import React from 'react';

import { HealthieTag } from '../hooks/queries/appointment-by-room-name/types';
import { HeaderInfoBlock } from './Header/components';
import { PATIENT_PROGRAM_ALLOWED_TAGS } from './PatientTags/constants';

interface PatientTagsProps {
  tags?: HealthieTag[];
}

const PatientTags: React.FC<PatientTagsProps> = ({ tags }) => {
  if (!Array.isArray(tags) || tags.length === 0) {
    return null;
  }

  const filteredTags = tags.filter((tag) =>
    PATIENT_PROGRAM_ALLOWED_TAGS.includes(tag.name),
  );

  if (filteredTags.length === 0) {
    return null;
  }

  return (
    <VStack gap={0}>
      <HeaderInfoBlock label="Patient Program" />
      <HStack spacing={2} flexWrap="wrap">
        {filteredTags.map((tag) => (
          <HStack
            key={tag.id}
            color="white"
            bg="rgba(255, 255, 255, 0.1)"
            padding="2px 6px"
            borderRadius="4px"
            border="1px solid rgba(255, 255, 255, 0.2)"
          >
            <Text fontSize="11px" fontWeight="500" opacity={0.9}>
              {tag.name}
            </Text>
          </HStack>
        ))}
      </HStack>
    </VStack>
  );
};

export default PatientTags;
